import { render, staticRenderFns } from "./tabPane.vue?vue&type=template&id=cb88c7c8"
import script from "./tabPane.vue?vue&type=script&lang=js"
export * from "./tabPane.vue?vue&type=script&lang=js"
import style0 from "./tabPane.vue?vue&type=style&index=0&id=cb88c7c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports